import { useState } from "react";
import { toast } from "sonner";

const STORAGE_KEY = "mp_inquiries";
const INITIAL = { name: "", email: "", phone: "", address: "", region: "", type: "", nda: "", about: "" };

export function useInquiryForm() {
  const [form, setForm] = useState(INITIAL);
  const set = (key, value) => setForm((f) => ({ ...f, [key]: value }));

  const submit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email) {
      toast.error("Please add your name and email.");
      return;
    }
    // Mock submit (frontend-only)
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    saved.push({ ...form, at: new Date().toISOString() });
    localStorage.setItem(STORAGE_KEY, JSON.stringify(saved));
    toast.success("Thank you — your inquiry has been sent.");
    setForm(INITIAL);
  };

  return { form, set, submit };
}
